module.exports = __webpack_public_path__ + "static/SortTheCourt3-70f9902611e8c993cc264ac79908301e.webp";